import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {useEffect, useState} from "react";
import useAlert from "../component/Alert/useAlert";
import Typography from "@mui/material/Typography";
import DiscountApiService from "../services/discount.api.service";
import {DiscountTraceTable} from "../component/DiscountTrace/DiscountTraceTable";
import Box from "@mui/material/Box";

const mdTheme = createTheme();

function DiscountTraceContent() {
    const [state, setState] = useState({
        traces: [],
        loading: false,
    });
    const [filters, setFilters] = useState({
        action: null,
        createdFrom: null,
        createdTo: null,
        discount: null,
    });
    const { showErrorAlert } = useAlert();
    useEffect(() => {loadTraces()}, [filters])
    const changeFilters = (partialState) => setFilters(currentState => ({...currentState, ...partialState}));
    const changeState = (partialState) => setState(currentState => ({...currentState, ...partialState}));
    const startLoading = () => changeState({loading: true});
    const stopLoading = () => changeState({loading: false});

    const loadTraces = () => {
        startLoading();
        DiscountApiService
            .trace(filters)
            .then(result => changeState({traces: result.items}))
            .catch(err => showErrorAlert(err.response.data.message))
            .finally(() => stopLoading());
    };

  return (
      <ThemeProvider theme={mdTheme}>
          <CssBaseline />
          <Box
              component="main"
              sx={{
                  padding: 2,
                backgroundColor: (theme) =>
                    theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900],
                flexGrow: 1,
                height: '100vh',
                overflow: 'auto',
              }}
          >
              <Typography component="h1" variant="h6" color="inherit" noWrap sx={{ padding: 5, textAlign: 'center' }}>
                  Discount chainscan
              </Typography>
              <DiscountTraceTable traces={state.traces} />
          </Box>
      </ThemeProvider>
  );
}

export default function DiscountTrace() {
  return <DiscountTraceContent />;
}
